import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { CATEGORIES, PRODUCTS } from '@/data/products';
import Bottle from '@/components/ui/Bottle';

export default function CategoryStrip() {
  return (
    <section className="container-x pb-16" data-testid="category-strip">
      <div className="flex items-end justify-between mb-8 gap-6">
        <div>
          <span className="eyebrow">Explore Ranges</span>
          <h2 className="font-display text-4xl lg:text-5xl text-bone-50 mt-3 tracking-tight">
            Find your <span className="italic text-sage-300">flavour</span>.
          </h2>
        </div>
        <Link to="/shop" className="hidden md:inline-flex btn-outline !py-2.5 !px-5">
          View All <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {CATEGORIES.map((cat, i) => {
          const sample = PRODUCTS.find((p) => p.category === cat.slug);
          return (
            <Link
              to={`/shop?cat=${cat.slug}`}
              key={cat.slug}
              data-testid={`category-${cat.slug}`}
              className="group relative glass-card rounded-3xl p-5 h-72 flex flex-col justify-between overflow-hidden hover:border-gold/30 transition-all"
            >
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity"
                style={{ background: `radial-gradient(ellipse at center bottom, ${cat.tone}22, transparent 70%)` }}
              />
              <div className="relative z-10">
                <h3 className="font-display text-xl text-bone-50">{cat.name}</h3>
                <p className="text-[11px] tracking-[0.18em] uppercase text-bone-300/80 mt-1">{cat.tagline}</p>
              </div>
              <div className="relative z-10 flex items-end justify-between">
                {sample && (
                  <div className="-mb-2">
                    <Bottle product={sample} size="sm" />
                  </div>
                )}
                <span className="w-9 h-9 rounded-full border border-bone-100/15 flex items-center justify-center group-hover:bg-gold group-hover:border-gold group-hover:text-ink-900 transition-colors shrink-0 self-end">
                  <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </Link>
          );
        })}
        <Link
          to="/shop"
          data-testid="category-all"
          className="group relative rounded-3xl p-5 h-72 flex flex-col justify-between overflow-hidden bg-gradient-to-br from-sage-500/30 to-sage-600/20 border border-sage-300/20 hover:border-sage-300/60 transition-all"
        >
          <div>
            <h3 className="font-display text-xl text-bone-50">View All Products</h3>
            <p className="text-[11px] tracking-[0.18em] uppercase text-bone-100/70 mt-1">The complete shelf</p>
          </div>
          <div className="flex items-center justify-between text-bone-50 text-sm">
            <span>Explore Now</span>
            <ArrowRight className="w-4 h-4" />
          </div>
        </Link>
      </div>
    </section>
  );
}
